webpackJsonp([0],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(11);

__webpack_require__(194);

__webpack_require__(197);

__webpack_require__(199);

__webpack_require__(202);

__webpack_require__(203);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _highlight = __webpack_require__(4);

var _highlight2 = _interopRequireDefault(_highlight);

__webpack_require__(191);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__(192)();

_riot2.default.tag('file-coverage', template, function (opts) {
  this.file = window.file;
  var code = _highlight2.default.highlightAuto(this.file.source).value;
  this.coverageInfo = _lodash2.default.zip(code.split('\n'), this.file.coverage);
});

/***/ }),

/***/ 191:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ctable class=\"table source\"\u003E\u003Ccaption\u003E{ file.name }\u003C\u002Fcaption\u003E\u003Ctbody\u003E\u003Ctr class=\"{covered: line[1] &gt; 0, missed: line[1] === 0}\" each=\"{ line, i in coverageInfo }\"\u003E\u003Ctd class=\"num\"\u003E{ i + 1 }\u003C\u002Ftd\u003E\u003Ctd class=\"code\"\u003E\u003Cpre\u003E\u003Craw html=\"{ line[0] }\"\u003E\u003C\u002Fraw\u003E\u003C\u002Fpre\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"hits\"\u003E\u003Cspan class=\"hits-number\" if=\"{ line[1] &gt; 0 }\"\u003E{ line[1] }x\u003C\u002Fspan\u003E\u003Cspan class=\"missed-sign\" if=\"{ line[1] === 0 }\"\u003E✗\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

__webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__(196)();

_riot2.default.tag('project-token', template, function (opts) {
  var _this = this;

  this.token = opts.token;
  this.shown = false;

  this.toggleShown = function () {
    _this.shown = !_this.shown;
    if (_this.shown) {
      setTimeout(function () {
        return _this['token-input'].select();
      }, 10);
    } else {
      _this.root.children[0].blur();
    }
  };

  this.computeWidth = function () {
    return _this.token.length * 5;
  };
});

/***/ }),

/***/ 195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ca onclick=\"{ toggleShown }\" href=\"javascript:void(0)\"\u003E\u003Ci class=\"{ fa: true, 'fa-eye': !shown, 'fa-eye-slash': shown }\"\u003E\u003C\u002Fi\u003E\u003Cinput class=\"token\" if=\"{ shown }\" value=\"{ token }\" readonly riot-style=\"width: { computeWidth() }px\" name=\"token-input\"\u003E\u003Cspan if=\"{ !shown }\"\u003EShow token\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

__webpack_require__(198);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_riot2.default.tag('selectable', '<textarea readonly onclick="{ selectText }" rows="{ opts.rows }">' + '{ opts.text }</textarea>', function (opts) {
  var _this = this;

  this.selectText = function (e) {
    e.stopPropagation();
    _this.root.children[0].select();
  };
});

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

__webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = __webpack_require__(201)();

_riot2.default.tag('badges', template, function (opts) {
  var _this = this;

  var splitted = opts.badgeUrl.split('.');
  var baseURL = splitted.slice(0, splitted.length - 1).join('.');

  var setFormat = function setFormat(format) {
    _this.format = format;
    _this.badgeURL = [baseURL, _this.format].join('.');
  };

  setFormat(splitted[splitted.length - 1]);

  this.handleClickFormat = function (e) {
    setFormat(e.target.dataset.format);
  };
});

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pug_has_own_property = Object.prototype.hasOwnProperty;

/**
 * Merge two attribute objects giving precedence
 * to values in object `b`. Classes are special-cased
 * allowing for arrays and merging/joining appropriately
 * resulting in a string.
 *
 * @param {Object} a
 * @param {Object} b
 * @return {Object} a
 * @api private
 */

exports.merge = pug_merge;
function pug_merge(a, b) {
  if (arguments.length === 1) {
    var attrs = a[0];
    for (var i = 1; i < a.length; i++) {
      attrs = pug_merge(attrs, a[i]);
    }
    return attrs;
  }

  for (var key in b) {
    if (key === 'class') {
      var valA = a[key] || [];
      a[key] = (Array.isArray(valA) ? valA : [valA]).concat(b[key] || []);
    } else if (key === 'style') {
      var valA = pug_style(a[key]);
      var valB = pug_style(b[key]);
      a[key] = valA + valB;
    } else {
      a[key] = b[key];
    }
  }

  return a;
};

/**
 * Process array, object, or string as a string of classes delimited by a space.
 *
 * If `val` is an array, all members of it and its subarrays are counted as
 * classes. If `escaping` is an array, then whether or not the item in `val` is
 * escaped depends on the corresponding item in `escaping`. If `escaping` is
 * not an array, no escaping is done.
 *
 * If `val` is an object, all the keys whose value is truthy are counted as
 * classes. No escaping is done.
 *
 * If `val` is a string, it is counted as a class. No escaping is done.
 *
 * @param {(Array.<string>|Object.<string, boolean>|string)} val
 * @param {?Array.<string>} escaping
 * @return {String}
 */
exports.classes = pug_classes;
function pug_classes_array(val, escaping) {
  var classString = '', className, padding = '', escapeEnabled = Array.isArray(escaping);
  for (var i = 0; i < val.length; i++) {
    className = pug_classes(val[i]);
    if (!className) continue;
    escapeEnabled && escaping[i] && (className = pug_escape(className));
    classString = classString + padding + className;
    padding = ' ';
  }
  return classString;
}
function pug_classes_object(val) {
  var classString = '', padding = '';
  for (var key in val) {
    if (key && val[key] && pug_has_own_property.call(val, key)) {
      classString = classString + padding + key;
      padding = ' ';
    }
  }
  return classString;
}
function pug_classes(val, escaping) {
  if (Array.isArray(val)) {
    return pug_classes_array(val, escaping);
  } else if (val && typeof val === 'object') {
    return pug_classes_object(val);
  } else {
    return val || '';
  }
}

/**
 * Convert object or string to a string of CSS styles delimited by a semicolon.
 *
 * @param {(Object.<string, string>|string)} val
 * @return {String}
 */

exports.style = pug_style;
function pug_style(val) {
  if (!val) return '';
  if (typeof val === 'object') {
    var out = '';
    for (var style in val) {
      /* istanbul ignore else */
      if (pug_has_own_property.call(val, style)) {
        out = out + style + ':' + val[style] + ';';
      }
    }
    return out;
  } else {
    val += '';
    if (val[val.length - 1] !== ';') 
      return val + ';';
    return val;
  }
};

/**
 * Render the given attribute.
 *
 * @param {String} key
 * @param {String} val
 * @param {Boolean} escaped
 * @param {Boolean} terse
 * @return {String}
 */
exports.attr = pug_attr;
function pug_attr(key, val, escaped, terse) {
  if (val === false || val == null || !val && (key === 'class' || key === 'style')) {
    return '';
  }
  if (val === true) {
    return ' ' + (terse ? key : key + '="' + key + '"');
  }
  if (typeof val.toJSON === 'function') {
    val = val.toJSON();
  }
  if (typeof val !== 'string') {
    val = JSON.stringify(val);
    if (!escaped && val.indexOf('"') !== -1) {
      return ' ' + key + '=\'' + val.replace(/'/g, '&#39;') + '\'';
    }
  }
  if (escaped) val = pug_escape(val);
  return ' ' + key + '="' + val + '"';
};

/**
 * Render the given attributes object.
 *
 * @param {Object} obj
 * @param {Object} terse whether to use HTML5 terse boolean attributes
 * @return {String}
 */
exports.attrs = pug_attrs;
function pug_attrs(obj, terse){
  var attrs = '';

  for (var key in obj) {
    if (pug_has_own_property.call(obj, key)) {
      var val = obj[key];

      if ('class' === key) {
        val = pug_classes(val);
        attrs = pug_attr(key, val, false, terse) + attrs;
        continue;
      }
      if ('style' === key) {
        val = pug_style(val);
      }
      attrs += pug_attr(key, val, false, terse);
    }
  }

  return attrs;
};

/**
 * Escape the given string of `html`.
 *
 * @param {String} html
 * @return {String}
 * @api private
 */

var pug_match_html = /["&<>]/;
exports.escape = pug_escape;
function pug_escape(_html){
  var html = '' + _html;
  var regexResult = pug_match_html.exec(html);
  if (!regexResult) return _html;

  var result = '';
  var i, lastIndex, escape;
  for (i = regexResult.index, lastIndex = 0; i < html.length; i++) {
    switch (html.charCodeAt(i)) {
      case 34: escape = '&quot;'; break;
      case 38: escape = '&amp;'; break;
      case 60: escape = '&lt;'; break;
      case 62: escape = '&gt;'; break;
      default: continue;
    }
    if (lastIndex !== i) result += html.substring(lastIndex, i);
    lastIndex = i + 1;
    result += escape;
  }
  if (lastIndex !== i) return result + html.substring(lastIndex, i);
  else return result;
};

/**
 * Re-throw the given `err` in context to the
 * the pug in `filename` at the given `lineno`.
 *
 * @param {Error} err
 * @param {String} filename
 * @param {String} lineno
 * @param {String} str original source
 * @api private
 */

exports.rethrow = pug_rethrow;
function pug_rethrow(err, filename, lineno, str){
  if (!(err instanceof Error)) throw err;
  if ((typeof window != 'undefined' || !filename) && !str) {
    err.message += ' on line ' + lineno;
    throw err;
  }
  try {
    str = str || __webpack_require__(193).readFileSync(filename, 'utf8')
  } catch (ex) {
    pug_rethrow(err, null, lineno)
  }
  var context = 3
    , lines = str.split('\n')
    , start = Math.max(lineno - context, 0)
    , end = Math.min(lines.length, lineno + context);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? '  > ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'Pug') + ':' + lineno
    + '\n' + context + '\n\n' + err.message;
  throw err;
};


/***/ }),

/***/ 200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cul class=\"nav nav-pills formats\"\u003E\u003Cli class=\"{active: format === 'svg'}\"\u003E\u003Ca href=\"javascript:void(0)\" data-format=\"svg\" onclick=\"{ handleClickFormat }\"\u003ESVG\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003Cli class=\"{active: format === 'png'}\"\u003E\u003Ca href=\"javascript:void(0)\" data-format=\"png\" onclick=\"{ handleClickFormat }\"\u003EPNG\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdl class=\"badge-list\"\u003E\u003Cdt\u003EURL\u003C\u002Fdt\u003E\u003Cdd\u003E\u003Cselectable text=\"{ badgeURL }\" rows=\"1\"\u003E\u003C\u002Fselectable\u003E\u003C\u002Fdd\u003E\u003Cdt\u003EMarkdown\u003C\u002Fdt\u003E\u003Cdd\u003E\u003Cselectable text=\"[![Coverage Status]({ badgeURL })]({ opts.projectUrl })\" rows=\"3\"\u003E\u003C\u002Fselectable\u003E\u003C\u002Fdd\u003E\u003Cdt\u003EHTML\u003C\u002Fdt\u003E\u003Cdd\u003E\u003Cselectable text=\"&lt;a href=&quot;{ opts.projectUrl }&quot;&gt;&lt;img src=&quot;{  badgeURL }&quot; alt=&quot;Coverage status&quot;&gt;&lt;\u002Fa&gt;\" rows=\"4\"\u003E\u003C\u002Fselectable\u003E\u003C\u002Fdd\u003E\u003C\u002Fdl\u003E";;return pug_html;};
module.exports = template;

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var template = '<div onclick="{ preventClick }"><yield /></div>';

_riot2.default.tag('click-safe', template, function (opts) {
  this.preventClick = function (e) {
    e.stopPropagation();
  };
});

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(204);

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_riot2.default.tag('raw', '<span></span>', function (opts) {
  this.root.innerHTML = opts.html;
});

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _riot = __webpack_require__(1);

var _riot2 = _interopRequireDefault(_riot);

__webpack_require__(7);

__webpack_require__(8);

__webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_riot2.default.mount('*');

// Fix logout link
$(document).off('click.bs.dropdown.data-api', '.dropdown form');
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function() {
  var PolyfillEvent = eventConstructor();

  function eventConstructor() {
    if (typeof window.CustomEvent === "function") return window.CustomEvent;
    // IE<=9 Support
    function CustomEvent(event, params) {
      params = params || {bubbles: false, cancelable: false, detail: undefined};
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    return CustomEvent;
  }

  function buildHiddenInput(name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    return input;
  }

  function handleClick(element) {
    var to = element.getAttribute("data-to"),
        method = buildHiddenInput("_method", element.getAttribute("data-method")),
        csrf = buildHiddenInput("_csrf_token", element.getAttribute("data-csrf")),
        form = document.createElement("form"),
        target = element.getAttribute("target");

    form.method = (element.getAttribute("data-method") === "get") ? "get" : "post";
    form.action = to;
    form.style.display = "hidden";

    if (target) form.target = target;

    form.appendChild(csrf);
    form.appendChild(method);
    document.body.appendChild(form);
    form.submit();
  }

  window.addEventListener("click", function(e) {
    var element = e.target;

    while (element && element.getAttribute) {
      var phoenixLinkEvent = new PolyfillEvent('phoenix.link.click', {
        "bubbles": true, "cancelable": true
      });

      if (!element.dispatchEvent(phoenixLinkEvent)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }

      if (element.getAttribute("data-method")) {
        handleClick(element);
        e.preventDefault();
        return false;
      } else {
        element = element.parentNode;
      }
    }
  }, false);

  window.addEventListener('phoenix.link.click', function (e) {
    var message = e.target.getAttribute("data-confirm");
    if(message && !window.confirm(message)) {
      e.preventDefault();
    }
  }, false);
})();


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[5]);


// WEBPACK FOOTER //
// app.js